import type { AppSession, Role } from '../../shared/types/domain';
import { demoOrganizationRepository } from '../organization/demoOrganizationRepository';

const STORAGE_KEY = 'boom-v4-demo-session';

const demoProfiles: Record<Role, AppSession['profile']> = {
  member: { id: '10000000-0000-4000-8000-000000000001', phone: '18800000001', name: '演示会员', role: 'member', status: 'active', storeId: '20000000-0000-4000-8000-000000000001', storeName: '武汉天地店' },
  employee: { id: '10000000-0000-4000-8000-000000000002', phone: '18800000002', name: '演示员工', role: 'employee', status: 'active', storeId: '20000000-0000-4000-8000-000000000001', storeName: '武汉天地店' },
  manager: { id: '10000000-0000-4000-8000-000000000003', phone: '18800000003', name: '演示店长', role: 'manager', status: 'active', storeId: '20000000-0000-4000-8000-000000000001', storeName: '武汉天地店' },
  super: { id: '10000000-0000-4000-8000-000000000004', phone: '18800000004', name: '演示超管', role: 'super', status: 'active', storeId: null, storeName: null },
};

export const demoAuth = {
  async restore(): Promise<AppSession | null> {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      const session = JSON.parse(raw) as AppSession;
      const account = (await demoOrganizationRepository.getState()).accounts.find((item) => item.id === session.profile.id);
      return session.profile.status === 'active' && account?.status === 'active' ? session : null;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  },
  async signInWithPassword() {
    throw new Error('演示模式不验证手机号密码，请使用四角色演示入口。');
  },
  async signInAsDemo(role: Role): Promise<AppSession> {
    const account = (await demoOrganizationRepository.getState()).accounts.find((item) => item.id === demoProfiles[role].id);
    if (!account || account.status !== 'active') throw new Error('该演示账号已停用，不能登录。');
    const session: AppSession = { accessToken: `demo-${role}`, profile: demoProfiles[role], expiresAt: null, source: 'demo' };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    return session;
  },
  async signOut() {
    localStorage.removeItem(STORAGE_KEY);
  },
};
